import { Component , EventEmitter , Output , Input , OnChanges, SimpleChanges} from '@angular/core';
import { FastAPIService, Solver } from 'src/app/service/fast-api.service';
import { ExampleItem } from '../nlp-example/nlp-example.component';
import { lastValueFrom } from 'rxjs';
@Component({
  selector: 'app-nlp-question',
  templateUrl: './nlp-question.component.html',
  styleUrls: ['./nlp-question.component.scss']
})
export class NlpQuestionComponent implements OnChanges{
  @Output() isLoadingChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() whenSubmit: EventEmitter<ExampleItem> = new EventEmitter<ExampleItem>();
  @Input() receivedData: ExampleItem | null = {date: null, text: null};
  constructor (private service: FastAPIService) {}

  question: string = "";
  searchQuestion: string = "";
  nlpResult: any;
  nerResult: any;
  nerKey: any;
  nerValue: any;
  synonym: any;
  isLoading: boolean = true;
  isNotHistory: boolean = true;

  filter = new Solver().solve().filter;

  ngOnChanges(changes: SimpleChanges): void {
    const receivedDataChanges = changes['receivedData'];
    if (receivedDataChanges && !receivedDataChanges.firstChange && receivedDataChanges.currentValue.text !== this.question) {
      const newData = changes['receivedData'].currentValue;
      this.question = newData.text;
      this.isNotHistory = false;
      this.getNlp(newData.text);
    } else {
      window.scrollTo({top:0, behavior: 'smooth'});
    }
  }

  pressEnter(event: any, question: string) {
    if (!question || question.trim() === '') {
      event.target.blur();
      return
    }
    this.getNlp(question);
  }

  getNlp(question: string) {
    window.scrollTo({top:0, behavior: 'auto'});
    this.isLoading = false;
    this.isLoadingChange.emit(true);
    this.nlpResult = "";
    this.nerKey = "";
    this.nerValue = "";
    this.searchQuestion = question;

    const data = this.service.getNLPshowcase(question).subscribe((i) => {
      this.nlpResult = i.response.data;
      this.nerResult = i.response.data.NERTag;
      this.synonym = i.response.data.Synonym;
      // console.log(this.nlpResult)
      if (this.nerResult) {
        this.nerKey = Object.keys(this.nerResult);
        this.nerValue = Object.values(this.nerResult);
      }
    },
    (error) => {
      this.isLoadingChange.emit(false);
      this.isLoading = true;
      console.error("Error fetching NLP data:", error);
    },
    () => {
      const newItem: ExampleItem = {
        date: new Date(),
        text: this.question
      };
      if (this.isNotHistory) {
        this.service.saveQuestion(question, 0).subscribe((response) => {
        });
        this.whenSubmit.emit(newItem);
      }
      this.isNotHistory = true;
      this.isLoadingChange.emit(false);
      this.isLoading = true;
    })
  }
}
